import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=2b5c08e6"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInfo.vue?vue&type=style&index=0&id=2b5c08e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports